Ext.define('SA.Interval', {
    constructor(callback, delay) {
        this.id = setInterval(callback, delay);
    },

    cancel() {
        clearInterval(this.id);
    }
});